import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
import {
    parseStatus,
    formatterDateToUTC
} from '@/util/util'
import {
    baseUrl
} from '@/config/env';


export const projectWarrantyOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: '200',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "工程项目名称",
            prop: "name",
            type: 'select',
            span: 13,
            placeholder: '请选择客户端类型',
            // valueDefault:"JOINS_ENGINEER",
            dicData: DIC.TAGS_CLIENT_TYPE,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请选择客户端类型"
            }],
        },
        {
            label: "服务商名称",
            prop: "company",
            type: 'input',
            span: 13,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入标签名称"
            }],
        },
        {
            label: "质保类型",
            prop: "type",
            type: 'input',
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "服务质保卡",
            prop: "image",
            type: 'select',
            formsolt: true,
            solt: true
        },
        {
            label: "质保时间",
            prop: "time",
            type: "input",
            // sortable: true,
            formatter: function (row, value, label, column) {
                let time = row.time + parseStatus(DIC.SERVICE_WARRANTY_DATE_TYPE, row.type)
                return time
            },
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "工程项目名称",
            search: true,
            prop: "engineeringProjectName",
            type: 'input',
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            formatter: function (row, value, label, column) {
                let time = row.createTime * 1
                return formatterDateToUTC(time)
            },
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "创建人",
            prop: "createBy",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false,
            width: "110"
        },
    ]
};